import { computed } from 'vue';
import { useStoreGetters, useStore } from 'dashboard/composables/store';

export const useCallControlSettings = () => {
  const store = useStore();
  const getters = useStoreGetters();

  const currentAccountId = getters.getCurrentAccountId;

  const isEnabled = computed(
    () => getters.getCurrentUserCallControlEnabled.value
  );

  const callControlStatus = computed(() => ({
    enabled: isEnabled.value,
    label: isEnabled.value ? 'Ativado' : 'Desativado',
    description: isEnabled.value
      ? 'Recebendo chamadas'
      : 'Não recebendo chamadas',
  }));

  const setCallControl = callControlEnabled => {
    store.dispatch('updateCallControl', {
      accountId: currentAccountId.value,
      callControlEnabled,
    });
  };

  const toggleCallControl = () => setCallControl(!isEnabled.value);
  const enableCallControl = () => setCallControl(true);
  const disableCallControl = () => setCallControl(false);

  return {
    isEnabled,
    callControlStatus,
    toggleCallControl,
    enableCallControl,
    disableCallControl,
  };
};
